module.exports = __webpack_public_path__ + "static/img/pcl2.28802f6e.png";